import { isEmpty, isNumber, isFinite, isString, trim } from "lodash";

export default function isBlank(value) {
  if (isNumber(value)) return !isFinite(value);
  if (isString(value)) return isEmpty(trim(value));
  return isEmpty(value);
}
